import { api } from '@src/constants/api';
import { createMiddleware, Next, regularErrorHandling, regularThenResponse } from '@src/utils';
import { projectsActions } from '@src/store/reducers/projectsReducer';
import { SessionService } from '@src/services';

export const createProjectsMiddleware = (http: any, sessionService: SessionService) => {
    const restServiceUrl: string = api.restServiceUrl;
    return createMiddleware({
        [projectsActions.GET_PROJECT_META_DATA]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}Projects/${action.payload.projId}/WithMetaData`);
                // Object.keys(response.data.options).forEach((key: any) => {
                //     if (response.data.options[key] === 'True' || response.data.options[key] === 'true') {
                //         response.data.options[key] = true;
                //     }
                //     if (response.data.options[key] === 'False' || response.data.options[key] === 'false') {
                //         response.data.options[key] = false;
                //     }
                // });
                next({ type: projectsActions.SET_PROJECT_MEAT_DATA, payload: response.data });
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectsActions.GET_PROJECTS]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}projects`);
                next({ type: projectsActions.SET_PROJECTS, payload: response.data });
                return response.data;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectsActions.GET_CONFLICT_OPTIONS]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}projects/ConflictOptions`);
                next({ type: projectsActions.SET_CONFLICT_OPTIONS, payload: response.data });
                return response.data;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },

        [projectsActions.GET_RAWDATA]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}projects/GetScriptExecutionLog/${action.payload.projectId}/${action.payload.jobQid}/${action.payload.executionId}/RawData`);
                next({ type: projectsActions.SET_RAWDATA, payload: response.data });
                return response.data;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },



        [projectsActions.UPDATE_SOURCE_CONTROL]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}projects/${action.payload.projectId}/UpdateSourceControl/${action.payload.envId}`);
                next({ type: projectsActions.SET_UPDATE_SOURCE_CONTROL, payload: response.data });
                return response.data;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        
        [projectsActions.GET_PROJECTS_WITH_DEPLOY_STATUS]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}projects/WithDeployStatusModified`);
                next({ type: projectsActions.SET_PROJECTS_WITH_DEPLOY_STATUS, payload: response.data });
                return response.data;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectsActions.DELETE_PROJECT]: async (action: any, _: Next, state: any) => {
            try {
                const response = await http.delete(`${restServiceUrl}projects/${action.payload.id}`);
                return regularThenResponse(response, action, (response: any) => {
                    if (response.data) {
                        sessionService.remove(`project_${action.payload.id}`);
                        state.dispatch({ type: projectsActions.GET_PROJECTS });
                        state.dispatch({ type: projectsActions.GET_PROJECTS_WITH_DEPLOY_STATUS });
                    }
                });
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectsActions.DELETE_DRAFT]: async (action: any, _: Next, state: any) => {
            try {
                const response = await http.delete(`${restServiceUrl}projects/draft/${action.payload.id}`);
                return regularThenResponse(response, action, (response: any) => {
                    if (response.data) {
                        sessionService.remove(`project_${action.payload.id}`);
                        state.dispatch({ type: projectsActions.GET_PROJECTS });
                        state.dispatch({ type: projectsActions.GET_PROJECTS_WITH_DEPLOY_STATUS });
                    }
                });
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/projects.middleware.ts